import type { FC, ReactNode } from 'react'
import { ImageCard } from '@/components/commons/image-card'
import { Separator } from '@/components/ui/separator'
import { Skeleton } from '@/components/ui/skeleton'
import type { Space } from '@/features/photoset/types'
import { spaceNameToLabel } from '@/features/photoset/utils'

interface PhotosetSpaceElementProps {
	asSkeleton?: undefined
	spaceName: Space['key_name']
	spaceHeaderEndSlot?: ReactNode
	endSlot: ReactNode
}

interface PhotosetSpaceElementSkeletonProps {
	asSkeleton: true
	spaceName?: undefined
	spaceHeaderEndSlot?: undefined
	endSlot?: undefined
}

export const PhotosetSpaceElement: FC<
	PhotosetSpaceElementProps | PhotosetSpaceElementSkeletonProps
> = ({ asSkeleton, spaceName, spaceHeaderEndSlot, endSlot }) => {
	if (asSkeleton) {
		return (
			<div className='flex flex-col'>
				<div className='relative z-[1] flex w-full flex-col gap-1 px-6 py-4'>
					<Skeleton height={28} width={100} />
				</div>
				<Separator className='mb-4' orientation='horizontal' />
				<div className='flex gap-4'>
					<ImageCard asSkeleton />
					<ImageCard asSkeleton />
					<ImageCard asSkeleton />
					<ImageCard asSkeleton />
				</div>
			</div>
		)
	}

	return (
		<div className='flex flex-col'>
			<div className='relative z-[1] flex w-full flex-col gap-1 px-6 py-4'>
				<h3 className='font-medium text-lg text-neutral-900'>
					{spaceNameToLabel[spaceName]}
				</h3>
				{spaceHeaderEndSlot && (
					<h4 className='text-neutral-600 text-sm'>
						{spaceHeaderEndSlot}
					</h4>
				)}
			</div>

			<Separator orientation='horizontal' />

			{endSlot}
		</div>
	)
}

PhotosetSpaceElement.displayName = 'PhotosetSpaceElement'
